var map = {
	"./views/StarsGather.vue": [
		"cd89",
		"chunk-54c649cb",
		"about0~about1",
		"about0"
	],
	"./views/mobile/StarsGather.vue": [
		"ea85",
		"chunk-54c649cb",
		"about0~about1",
		"about1"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "de9c";
module.exports = webpackAsyncContext;